export function Empty({ title, job }: { title: string; job: string }) {
  return (
    <div className="mx-auto w-full max-w-[1240px] px-4 py-6 md:px-8 md:py-8">
      <h1 className="pb-6 text-xl font-medium tracking-title">{title}</h1>
      <section className="rounded-lg border border-dashed border-line-strong px-6 py-14">
        <div className="mx-auto max-w-[52ch] text-center">
          <h2 className="text-md font-medium">Nothing here yet</h2>
          <p className="mt-1 text-sm text-ink-2">{job}</p>
          <p className="mt-1 text-xs text-ink-3">This screen lands in a later ticket.</p>
        </div>
      </section>
    </div>
  );
}
